import React from 'react'

export const EventiProgrammaSectionSettings = (settingsProps) => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}

export const EventiProgrammaSectionFloatingSettings = () =>
  React.createElement(EventiProgrammaSectionSettings, { floating: true })
